import React from "react";
import { Button } from "../ButtonV2/Button";
import {
  FormMessage,
  FormMessageContainer,
  FormMessageTitle,
} from "./FormBuilder.styles";
import { FormElement } from "./FormBuilder.types";

interface SuccessMessageProps {
  feedbackElements: FormElement[];
  onBackToForm: () => void;
  palette?: {
    bgColor?: string;
    borderColor?: string;
    textColor?: string;
  };
}

const renderFeedback = (element: FormElement) => {
  const { type, props } = element;
  const key = `feedback-${element.id}`;

  if (type === "success_message" && props.showAfterSubmit) {
    return (
      <FormMessageContainer key={key}>
        <FormMessageTitle>{props.message}</FormMessageTitle>
      </FormMessageContainer>
    );
  }
  return null;
};

const SuccessMessage: React.FC<SuccessMessageProps> = ({
  feedbackElements,
  onBackToForm,
  palette,
}) => {
  return (
    <FormMessage>
      <FormMessageContainer>
        {feedbackElements.map(renderFeedback)}
        <Button
          type="button"
          size="full"
          palette={palette}
          onClick={onBackToForm}
          className="styleguide"
        >
          Voltar para o formulário
        </Button>
      </FormMessageContainer>
    </FormMessage>
  );
};

export default SuccessMessage;
